import RequestedTemplate from 'components/templates/RequestedTemplate'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'

/**
 * QN-11: 位置共有画面
 */
const LocationSharing: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state } = props

  return (
    <RequestedTemplate
      title={'位置共有画面'}
      requester={state.location}
      partner={state.partner}
      partnerStable={state.partnerStable}
      qnStatus={state.qnStatus}
      partnerName={state.partnerName}
      arrivalDuration={state.arrivalDuration}
      timeComingSoon={state.timeComingSoon}
      lastLocationSendDate={state.lastLocationSendDate}
      locationSharingTimeout={state.locationSharingTimeout}
      state={state}
    />
  )
}

export default LocationSharing
